import { useEffect } from "react";
import { getAuthenticatedUserProfile } from "../utils/authProfile";

const JIRA_ISSUE_COLLECTOR_FIELDS = {
  fullName: "fullname",
  email: "email",
};

const setCollectorFieldValues = ({ fullName, email }) => {
  if (typeof window === "undefined") {
    return;
  }

  window.__TAPP_JIRA_COLLECTOR_PREFILL__ = {
    fullname: fullName,
    email,
  };

  window.ATL_JQ_PAGE_PROPS = {
    ...window.ATL_JQ_PAGE_PROPS,
    fieldValues: {
      ...window.ATL_JQ_PAGE_PROPS?.fieldValues,
      [JIRA_ISSUE_COLLECTOR_FIELDS.fullName]: fullName,
      [JIRA_ISSUE_COLLECTOR_FIELDS.email]: email,
    },
  };

  window.applyJiraCollectorPrefill?.(0);
};

export const useJiraIssueCollector = (userData) => {
  const givenName = userData?.profile?.given_name;
  const familyName = userData?.profile?.family_name;
  const profileName = userData?.profile?.name;
  const profileEmail = userData?.profile?.email;

  useEffect(() => {
    const { fullName, email } = getAuthenticatedUserProfile(userData);

    setCollectorFieldValues({ fullName, email });
  }, [userData, givenName, familyName, profileName, profileEmail]);
};
